<template>
  <Teleport to="body">
    <transition name="popup-t">
      <div
        v-show="active"
        v-bind="$attrs"
        class="vs-component con-vs-popup"
        :class="[`vs-popup-${color}`, { fullscreen }]"
      >
        <div
          class="vs-popup--background"
          :style="containerStyle"
          @click="close"
        />
        <div class="vs-popup" :style="popupStyle">
          <header class="vs-popup--header" :style="headerStyle">
            <div class="vs-popup--title">
              <h3>{{ title }}</h3>
              <slot name="subtitle" />
            </div>
            <vs-icon
              v-if="!buttonCloseHidden"
              class="vs-popup--close vs-popup--close--icon"
              :style="popupStyle"
              :icon-pack="iconPack"
              :icon="iconClose"
              @click="close"
            />
          </header>
          <div
            class="vs-popup--content"
            :class="classContent"
            :style="styleContent"
          >
            <slot />
          </div>
        </div>
      </div>
    </transition>
  </Teleport>
</template>

<script>
const THEME_COLORS = [
  "primary",
  "secondary",
  "success",
  "danger",
  "warning",
  "dark",
  "light",
];

export default {
  name: "VsPopup",
  inheritAttrs: false,
  props: {
    color: {
      type: String,
      default: "primary",
    },
    active: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "popup",
    },
    buttonCloseHidden: {
      type: Boolean,
      default: false,
    },
    fullscreen: {
      type: Boolean,
      default: false,
    },
    backgroundColor: {
      type: String,
      default: null,
    },
    backgroundColorPopup: {
      type: String,
      default: "rgb(255,255,255)",
    },
    styleContent: {
      type: [String, Object],
      default: null,
    },
    classContent: {
      type: [String, Object, Array],
      default: null,
    },
    iconPack: {
      type: String,
      default: "material-icons",
    },
    iconClose: {
      type: String,
      default: "close",
    },
  },
  emits: ["update:active", "close"],
  computed: {
    headerStyle() {
      return {
        color: THEME_COLORS.includes(this.color) ? null : this.color,
      };
    },
    containerStyle() {
      return {
        background: this.backgroundColor,
      };
    },
    popupStyle() {
      return {
        background: this.backgroundColorPopup,
      };
    },
  },
  methods: {
    close() {
      this.$emit("update:active", false);
      this.$emit("close", false);
    },
  },
};
</script>
